<div class="switcher-wrapper" *ngIf="sites$ | async as site">
    <ng-container *ngIf="!(isMobile$ | async)">
        <a href="/countryselection">
            <img [src]="flagPath" />
            <span>{{ site.name }}</span>
        </a>
        <a *ngIf="site.languages && site.languages.length > 1"
            class="language-selection"
            (click)="toggleLanguageSelectionButton()">
            <span class="linkicon"></span>
            <span class="linktext" [ngClass]="{ opened: isLanguageSelectionOpen$ | async }">{{site.languageLocale.toUpperCase()}}</span>
        </a>
    </ng-container>
<!--mobile-->
    <a *ngIf="(isMobile$ | async) && (showLanguageSelection$ | async)"  class="language-selection" (click)="toggleLanguageSelectionButton()">
        <img [src]="flagPath" />
    </a>
    <a *ngIf="(isMobile$ | async) && !(showLanguageSelection$ | async)">
        <a href="/countryselection">
            <img [src]="flagPath" />
        </a>
    </a>
<!--dropdown-->
<div>
    <div *ngIf="(showLanguageSelection$ | async)" class="secondarynavdropdown" [ngClass]="{'mobile': (isMobile$ | async) , 'closed': !(isLanguageSelectionOpen$ | async) }">
        <ul class="reset" *ngIf="!(isMobile$ | async)">
            <li *ngFor="let lang of site.languages">
                <a *ngIf="lang.site.toLowerCase() !== site.site"
                    da-link
                    href="{{lang.site.toLowerCase() + '/home'}}"
                    [innerHTML]="lang.site.toUpperCase().slice(0,2)">
                </a>
            </li>
        </ul>
        <!--mobile-->
        <ul class="reset" *ngIf="isMobile$ | async">
            <li class="close-button">
                <button dw-button (click)="closeLanguageSelectionButton()" class="close"></button>
            </li>
            <ng-container *ngFor="let lang of site.languages">
                <li *ngIf="lang.site.toLowerCase() !== site.site" class="border-bottom">
                    <a dw-link
                        href="{{lang.site.toLowerCase() + '/home'}}"
                        [innerHTML]="lang.site.toUpperCase().slice(0,2)">
                    </a>
                </li>
            </ng-container>
            <li>
                <a
                    dw-link
                    href="/countryselection"
                    [innerHTML]="'Change Region'"
                ></a>
            </li>
        </ul>
    </div>
</div>
</div>
<div class="switcher-wrapper portals" *ngIf="portalLanguages$ | async as language">
    <a>
        <img [src]="flagPathforPortals$ | async" />
    </a>
    <a *ngIf="language.length > 1" class="language-selection" (click)="toggleLanguageSelectionButton()">{{(currentLang$ | async).toUpperCase() }}
        <span class="linktext" [ngClass]="{ opened: isLanguageSelectionOpen$ | async }"></span>
    </a>
    <div>
        <div class="secondarynavdropdown" [ngClass]="{'mobile': (isMobile$ | async) ,'closed': !(isLanguageSelectionOpen$ | async)}">
            <!--mobile-->
            <ul class="reset" *ngIf="isMobile$ | async">
                <li class="close-button">
                    <button dw-button (click)="closeLanguageSelectionButton()" class="close"></button>
                </li>
                <ng-container *ngFor="let lang of language">
                    <li *ngIf="lang.name !== (currentLang$ | async) && lang.name !== (currentLang$ | async).toLowerCase()" class="border-bottom" (click)="changeLanguageOfPortal(lang)">{{lang.name.toUpperCase()}}
                    </li>
                </ng-container>
            </ul>
            <!--desktop-->
            <ul class="reset" *ngIf="!(isMobile$ | async)">
                <ng-container *ngFor="let lang of language">
                    <li *ngIf="lang.name !== (currentLang$ | async) && lang.name !== (currentLang$ | async).toLowerCase()" class="border-bottom" (click)="changeLanguageOfPortal(lang)">{{lang.name.toUpperCase()}}
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</div>
